var React = require('react');

function Plus (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M10.4429 0V21.5","stroke":"white","strokeWidth":"2.5","key":0}),React.createElement("path",{"d":"M21.5 10.75L2.38419e-07 10.75","stroke":"white","strokeWidth":"2.5","key":1})]);
}

Plus.defaultProps = {"width":"22","height":"22","viewBox":"0 0 22 22","fill":"none"};

module.exports = Plus;

Plus.default = Plus;
